(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function() {
    var drawer = document.getElementById('cart-drawer');
    var overlay = document.getElementById('cart-drawer-overlay');
    var closeBtn = document.getElementById('cart-drawer-close');

    if (!drawer) return;

    var routes = window.routes || {};
    var FREE_SHIPPING = parseInt(drawer.dataset.freeShipping, 10) || 50000; /* cents */

    /* Helper condivisi (definiti in theme.liquid) */
    var esc = window.CN.esc;

    /* Unita di misura per riga carrello. /cart.js non espone i tag prodotto, quindi
       usiamo la property _unit scritta all'add-to-cart, con fallback sul titolo per
       i carrelli creati prima di questa modifica. Vedi snippets/unit-label.liquid. */
    var UNITS_AREA = { box: drawer.dataset.boxArea || 'Scatole', total: drawer.dataset.totalArea || 'm²' };
    var UNITS_LINEAR = { box: drawer.dataset.boxLinear || 'Pezzi', total: drawer.dataset.totalLinear || 'm lineari' };

    function unitLabels(item) {
      var flag = item.properties && item.properties._unit;
      if (flag) return flag === 'm' ? UNITS_LINEAR : UNITS_AREA;
      var title = (item.product_title || '').toLowerCase();
      return title.indexOf('battiscopa') !== -1 ? UNITS_LINEAR : UNITS_AREA;
    }

    function openCartDrawer(e) {
      if (e) e.preventDefault();
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function closeCartDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    var formatMoney = window.CN.money;

    /* Refresh drawer content via AJAX */
    function refreshDrawer() {
      return fetch((routes.cart_url || '/cart') + '.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var remaining = Math.max(0, FREE_SHIPPING - cart.total_price);
          var pct = Math.min(100, (cart.total_price / FREE_SHIPPING) * 100);

          /* Update title */
          drawer.querySelector('.cart-drawer__title').textContent = 'Carrello (' + cart.item_count + ')';

          /* Update header cart count */
          var countEl = document.querySelector('.header__cart-count');
          if (countEl) {
            countEl.textContent = cart.item_count;
            countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
          } else if (cart.item_count > 0) {
            var cartIcon = document.querySelector('.header__cart');
            if (cartIcon && !cartIcon.querySelector('.header__cart-count')) {
              var span = document.createElement('span');
              span.className = 'header__cart-count';
              span.textContent = cart.item_count;
              cartIcon.appendChild(span);
            }
          }

          /* Update shipping bar */
          var shippingText = drawer.querySelector('.cart-drawer__shipping-text');
          var progressBar = drawer.querySelector('.cart-drawer__progress-bar');
          if (cart.item_count === 0) {
            shippingText.innerHTML = 'Il tuo carrello e\' vuoto';
            shippingText.className = 'cart-drawer__shipping-text';
          } else if (remaining > 0) {
            shippingText.innerHTML = 'Ti mancano <strong>' + formatMoney(remaining) + '</strong> per la spedizione gratuita!';
            shippingText.className = 'cart-drawer__shipping-text';
          } else {
            shippingText.innerHTML = 'Spedizione gratuita!';
            shippingText.className = 'cart-drawer__shipping-text cart-drawer__shipping-text--free';
          }
          progressBar.style.width = pct + '%';

          /* Update items */
          var itemsContainer = drawer.querySelector('.cart-drawer__items');
          if (cart.items.length === 0) {
            itemsContainer.innerHTML = '';
          } else {
            var html = '';
            cart.items.forEach(function(item) {
              var imgSrc = item.image || (item.featured_image ? item.featured_image.url : '');
              if (imgSrc) imgSrc += (imgSrc.indexOf('?') === -1 ? '?' : '&') + 'width=150';
              /* m²/box metadata carried as a line item property when added */
              var mqBox = parseFloat((item.properties && item.properties._area_per_box) || 0);
              var units = unitLabels(item);
              html += '<div class="cart-drawer__item">';
              if (imgSrc) html += '<a href="' + esc(item.url) + '" class="cart-drawer__item-img-wrap"><img src="' + esc(imgSrc) + '" class="cart-drawer__item-img" loading="lazy"></a>';
              html += '<div class="cart-drawer__item-info">';
              html += '<a href="' + esc(item.url) + '" class="cart-drawer__item-title">' + esc(item.product_title.substring(0, 50)) + '</a>';
              if (mqBox > 0) {
                html += '<span class="cart-drawer__item-meta">' + esc(item.quantity + ' ' + units.box + ' | ' + (item.quantity * mqBox).toFixed(2) + ' ' + units.total) + '</span>';
              }
              html += '<div class="cart-drawer__item-bottom">';
              html += '<div class="cart-drawer__qty" data-qty-key="' + esc(item.key) + '">';
              html += '<button type="button" class="cart-drawer__qty-btn" data-qty-delta="-1" aria-label="Diminuisci quantita">−</button>';
              html += '<span class="cart-drawer__qty-val">' + item.quantity + '</span>';
              html += '<button type="button" class="cart-drawer__qty-btn" data-qty-delta="1" aria-label="Aumenta quantita">+</button>';
              html += '</div>';
              html += '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>';
              html += '</div>';
              html += '</div>';
              html += '<button class="cart-drawer__item-remove" data-remove-key="' + esc(item.key) + '" aria-label="Rimuovi">&times;</button>';
              html += '</div>';
            });
            itemsContainer.innerHTML = html;
            bindRemoveButtons();
            bindQtyButtons();
          }

          /* Update footer */
          var footer = drawer.querySelector('.cart-drawer__footer');
          var cartUrl = routes.cart_url || '/cart';
          var collectionsUrl = routes.collections_url || '/collections';
          if (cart.items.length > 0) {
            footer.innerHTML = '<div class="cart-drawer__total"><span>Subtotale</span><span><strong>' + formatMoney(cart.total_price) + '</strong></span></div>'
              + '<a href="' + esc(cartUrl) + '" class="cart-drawer__view-cart">Vedi carrello</a>'
              + '<form action="' + esc(cartUrl) + '" method="post"><button type="submit" name="checkout" class="cart-drawer__checkout">CHECKOUT</button></form>';
          } else {
            footer.innerHTML = '<a href="' + esc(collectionsUrl) + '" class="cart-drawer__view-cart">Continua lo shopping</a>';
          }
        });
    }

    /* Remove item from cart */
    function removeItem(key) {
      fetch((routes.cart_change_url || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(refreshDrawer);
    }

    function bindRemoveButtons() {
      drawer.querySelectorAll('[data-remove-key]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          removeItem(btn.dataset.removeKey);
        });
      });
    }
    bindRemoveButtons();

    /* Change line item quantity */
    function changeItemQty(key, qty) {
      if (qty < 1) qty = 1;
      fetch((routes.cart_change_url || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(refreshDrawer);
    }

    function bindQtyButtons() {
      drawer.querySelectorAll('.cart-drawer__qty').forEach(function(box) {
        var key = box.dataset.qtyKey;
        var val = box.querySelector('.cart-drawer__qty-val');
        var minusBtn = box.querySelector('[data-qty-delta="-1"]');
        var current = parseInt(val.textContent, 10) || 1;
        if (minusBtn) minusBtn.disabled = current <= 1;
        box.querySelectorAll('[data-qty-delta]').forEach(function(btn) {
          btn.addEventListener('click', function() {
            var now = parseInt(val.textContent, 10) || 1;
            var next = now + (parseInt(btn.dataset.qtyDelta, 10) || 0);
            if (next < 1) next = 1;
            if (next === now) return;
            val.textContent = next; /* optimistic, avoids double-click race */
            if (minusBtn) minusBtn.disabled = next <= 1;
            changeItemQty(key, next);
          });
        });
      });
    }
    bindQtyButtons();

    /* Intercept add-to-cart forms */
    document.addEventListener('submit', function(e) {
      var form = e.target;
      var action = form.getAttribute('action') || '';
      /* Only intercept add-to-cart forms */
      if (action.indexOf('/cart/add') === -1 && form.id !== 'product-form') return;
      if (form.querySelector('[name="checkout"]')) return;

      e.preventDefault();
      var data = new FormData(form);

      fetch((routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        body: data
      })
      .then(function(r) {
        if (!r.ok) return r.json().then(function(d) { throw d; });
        return r.json();
      })
      .then(function() {
        refreshDrawer().then(openCartDrawer);
        if (window.showToast) window.showToast('Prodotto aggiunto al carrello');
      })
      .catch(function(err) {
        var msg = (err && err.description) || 'Errore nell\'aggiunta al carrello. Riprova.';
        if (window.showToast) window.showToast(msg, 'error', 4000);
      });
    });

    /* Open on cart icon click */
    var cartIcon = document.querySelector('.header__cart');
    if (cartIcon) {
      cartIcon.addEventListener('click', function(e) {
        e.preventDefault();
        refreshDrawer().then(openCartDrawer);
      });
    }

    if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
    if (overlay) overlay.addEventListener('click', closeCartDrawer);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCartDrawer();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["toast"] && !Shopify.designMode) return;
  try {
    window.showToast = function(message, type, duration) {
    type = type || 'success';
    duration = duration || 3000;
    var toast = document.getElementById('toast');
    var text = document.getElementById('toast-text');
    var icon = document.getElementById('toast-icon');
    if (!toast || !text) return;

    text.textContent = message;
    icon.textContent = type === 'error' ? '\u2717' : '\u2713';
    toast.className = 'toast toast--' + type;
    toast.hidden = false;

    /* Force reflow for animation */
    toast.offsetHeight;
    toast.classList.add('is-visible');

    setTimeout(function() {
      toast.classList.remove('is-visible');
      setTimeout(function() { toast.hidden = true; }, 300);
    }, duration);
  };
  } catch(e) { console.error(e); }
})();

})();
